import React from 'react';
import { Check } from 'lucide-react';
import { getLocalizedText } from '../../utils/helpers';

export const PausedTab = ({ 
  pausedServices, 
  pausedCourses,
  pausedCount 
}) => {
  if (pausedCount === 0) {
    return (
      <div className="text-center py-12">
        <Check className="h-12 w-12 text-green-500 mx-auto mb-4" />
        <p className="text-gray-500">No hay elementos en pausa</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {pausedServices.length > 0 && (
        <div>
          <h3 className="font-semibold mb-4">Servicios en Pausa ({pausedServices.length})</h3>
          <div className="space-y-2">
            {pausedServices.map(service => (
              <div key={service.id} className="bg-gray-100 rounded-lg p-4 opacity-75">
                <p className="font-medium">{getLocalizedText(service.title, 'es')}</p>
                <p className="text-sm text-gray-500">{service.user_name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {pausedCourses.length > 0 && (
        <div>
          <h3 className="font-semibold mb-4">Cursos en Pausa ({pausedCourses.length})</h3>
          <div className="space-y-2">
            {pausedCourses.map(course => (
              <div key={course.id} className="bg-gray-100 rounded-lg p-4 opacity-75">
                <p className="font-medium">{getLocalizedText(course.title, 'es')}</p>
                <p className="text-sm text-gray-500">{course.school_name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
